import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SharedService } from '../../_service/shared.service';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { LeadsService } from '../../_service/leads.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
declare var $: any;

@Component({
  selector: 'app-affiliate-opds',
  templateUrl: './affiliate-opds.component.html',
  styleUrls: ['./affiliate-opds.component.css']
})
export class AffiliateOpdsComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('dateRangeStart', { static: false }) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', { static: false }) dateRangeEnd: ElementRef;

  perpage: number = 25; opdsList: any = []; length: number = 0; pageEvent: PageEvent; loading: boolean = true; role: string; pageSizeOptions = [10, 25, 50, 100]; pageIndex: number = 0; loaded: boolean = false; search: string; currentUserId: any; booleanValue: any = false; treatment = ''; treatments = []; treatments_copy = []; city = ""; cities = []; cities_copy = []; sc3Url: string = ''; payment_mode = ''; status = '';start_date: string = ''; end_date: string = '';userId:string;

  constructor(private sharedapi: SharedService, public leadapi: LeadsService, private dialog: MatDialog) { }

  ngOnInit(): void {
    this.sharedapi.getRole().subscribe((item:string) => {this.role=item;});
    this.role = localStorage.getItem('role');
    this.userId = localStorage.getItem('loginuserId');
    this.sc3Url = localStorage.getItem('s3url');
    this.getTreatment(); this.getcitiesList();
  }


  ngAfterViewInit() {
    this.loadOpds(0, this.perpage);
  }

  setSearchValue(type) {
    if (type == 'treatment') {
      $("#treatmentSearch").val('');
      $("#treatmentSearch").focus();
      this.treatments = this.treatments_copy;
    } else if (type == 'city') {
      $("#citySearch").val('');
      $("#citySearch").focus();
      this.cities = this.cities_copy;
    }
  }

  searchOnSelect(searchtText: string, type) {
    if (type == 'treatment') {
      this.treatments = this.sharedapi.searchData(searchtText, this.treatments_copy, "name");
    } else if (type == 'city') {
      this.cities = this.sharedapi.searchData(searchtText, this.cities_copy, "name");
    }
  }

  async loadOpds(pageIndex, perpage) {
    this.opdsList = [];
    this.paginator.pageIndex = pageIndex;
    let qString = 'search=' + this.search + '&treatment=' + this.treatment + '&city=' + this.city + '&payment_mode=' + this.payment_mode + '&status=' + this.status + '&date_range=' + this.start_date + '-' + this.end_date;
    this.loading = true; this.loaded = false;
    
    await this.leadapi.getAffiliateOpds(this.paginator.pageIndex, perpage, qString)
      .subscribe((data: any) => {
        this.length = parseInt(data.totaldata);
        this.loading = false;
        this.loaded = true;
        if (data.status) {
          this.opdsList = data.data;
        } else {
          this.opdsList = [];
          this.sharedapi.presentToast(data.msg);
        }
      }, error => {
        this.loading = false;
        this.loaded = true;
        this.sharedapi.checkError(error);
      });
  }


  pageChange(event) {
    this.pageIndex = event.pageIndex;
    this.loadOpds(event.pageIndex, event.pageSize);
  }

  public getServerData(event: PageEvent): any {
    this.perpage = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.loadOpds(event.pageIndex, event.pageSize);
  }

  async getTreatment() {
    await this.leadapi.getTreatments().subscribe((data: any) => {
      if (data.status) {
        this.treatments = data.data;
        this.treatments_copy = this.treatments;
      } else {
        this.treatments = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async getcitiesList() {
    await this.leadapi.getcities().subscribe((data: any) => {
      if (data.status) {
        this.cities = data.data;
        this.cities_copy = this.cities;
      } else {
        this.cities = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  resetFilters() {
    this.clearDate();
    this.search = ''; this.treatment = ''; this.city = ''; this.payment_mode = ''; this.status = '';
    this.loadOpds(0, 25);
  }

  dateRangeChange(date1, date2) {
    if (date2.value) {
      this.start_date = date1.value;
      this.end_date = date2.value;
    }
  }

  clearDate() {
    this.dateRangeStart.nativeElement.value = "";
    this.dateRangeEnd.nativeElement.value = "";
    this.start_date = '';
    this.end_date = '';
  }

}
